import { useState } from "react";
import { Link } from "react-router-dom";
import {
  getCompanySponsorRating,
  getCompanyStrength,
  getSponsorTypeBadge,
  websiteLink,
  toSlugUrl
} from "../../../helpers/helpers";
import ImageControl from "../../common/ImageControl";
import paths from "../../../constants/paths";

const sponsorConfig = {
  Active: {
    label: "Active Sponsor",
    icon: "/images/icon_mini_star.png",
    className: "active",
  },
  Inactive: {
    label: "Inactive Sponsor",
    icon: "/images/icon_mini_pause.png",
    className: "inactive",
  },
  Occasional: {
    label: "Occasional Sponsor",
    icon: "/images/icon_mini_refresh.png",
    className: "occasional",
  },
};

export default function CompanyBlock({ company }) {
  const company_data = {
    id: company?.id,
    encoded_id: company?.encoded_id,
    image: company?.image,
    name: company?.title,
    isNew: false,
    sponsorType: getSponsorTypeBadge(company?.sponsor_type),
    description: company?.short_desc,
    stats: [
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_file.png",
        text: company?.computed_cos_total ?? 0 + " CoS Issued",
      },
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_shield.png",
        text: getCompanySponsorRating(company?.sponsor_rating) + " Sponsor",
      },
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_chart.png",
        text: "Sponsorship Strength: " + getCompanyStrength(company?.strength),
      },
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_check.png",
        text:
          company?.overseas_applicants == "yes"
            ? "Accepts applicants from overseas candidates."
            : "Does not accept applicants from overseas",
      },
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_visa.png",
        text: company?.visa_support,
      },
    ],
    tags: company?.industry_tags,
    openPositions: company?.job_count > 0 ? company?.job_count : 0,
  };
  const [bookmarked, setBookmarked] = useState(false);

  return (
    <>
      <div className="company_block w-100">
        <div className="icon">
          {/* <img src={company_data?.image} alt={company_data?.name} /> */}

          {company_data?.image == "" || company_data?.image == null ? (
            <img
              src={paths.SITE_BASE_URL + "/images/no-image.svg"}
              alt="no image found"
            />
          ) : (
            <ImageControl
              src={company_data?.image}
              folder="companies"
              isThumb={true}
            />
          )}
        </div>
        <div className="text">
          <div className="top_heading">
            <div className="heading h4 m-0">
              <Link
                to={websiteLink(`/company-details/${company_data.encoded_id}/${toSlugUrl(company_data?.name)}`)}
              >
                {company_data?.name}
              </Link>
              {company_data?.sponsorType && company_data?.sponsorType}
              {company_data?.isNew && <div className="new_badge">NEW</div>}
            </div>
            {/* <button
							type="button"
							className={`${bookmarked ? "bookmarked" : ""}  bookmark`}
							onClick={() => setBookmarked((prev) => !prev)}
						>
							<img
								src={
									bookmarked
										? "/images/icon_mini_bookmark_fill.png"
										: "/images/icon_mini_bookmark.png"
								}
								alt="Bookmark"
							/>
						</button> */}
          </div>
          {company_data?.description && <p>{company_data?.description}</p>}
          <ul className="mini_list">
            {company_data?.stats?.map((item, index) => (
              <li key={index}>
                <img src={item?.icon} alt="" />
                {item?.text}
              </li>
            ))}
          </ul>
          {company_data?.tags.length > 0 && (
            <div className="tag_list">
              {company_data?.tags?.map((tag, index) => (
                <button key={index} type="button">
                  {tag}
                </button>
              ))}
            </div>
          )}
          <div className="btm_blk">
            <span>{company_data?.openPositions} Verified Jobs</span>
            <Link
              to={websiteLink(`/company-details/${company_data.encoded_id}/${toSlugUrl(company_data?.name)}`)}
            >
              View
              {/* <img src={paths.SITE_BASE_URL + "/images/icon_arrow.png"} alt="" /> */}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
